// extracted by mini-css-extract-plugin
export default {"container":"styles_container__BiKh-","main":"styles_main__3SIQN","footer":"styles_footer__OHJnn","header":"styles_header__JbPEk","title":"styles_title__HjR5V"};